import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled from "@emotion/styled";

const Wrapper = styled.footer({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: "0.5rem 1.5rem",
  marginTop: "4rem",
  paddingTop: "1.5rem",
  borderTop: "1px solid var(--border)",
  color: "var(--textMuted)",
  "& a": {
    color: "var(--textNormal)",
    textDecoration: "none",
  },
  "& a:hover": {
    textDecoration: "underline",
  },
});

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      site {
        siteMetadata {
          author {
            name
          }
          contactEmail
          social {
            github
            linkedin
          }
        }
      }
    }
  `);
  const { author, contactEmail, social } = data.site.siteMetadata;

  return (
    <Wrapper>
      <span>
        © {new Date().getFullYear()} {author.name}
      </span>
      <span>
        <a href={social.github} target="_blank" rel="noopener noreferrer">
          GitHub
          <span className="visually-hidden"> (opens in new tab)</span>
        </a>
        {" · "}
        <a href={social.linkedin} target="_blank" rel="noopener noreferrer">
          LinkedIn
          <span className="visually-hidden"> (opens in new tab)</span>
        </a>
        {" · "}
        <a href={`mailto:${contactEmail}`}>Email</a>
      </span>
    </Wrapper>
  );
};

export default Footer;
